import React, {useEffect,useState} from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Mainmastet from './masterpage/Mainmastet.js';
import ContactPage from './pages/ContactPage.js';
import Products from './pages/Products.js';
import ProductDetails from './pages/ProductDetails.js';
import ProductDetailsP from './pages/ProductDetailsP.js';
import ProductDetailsU from './pages/ProductDetailsU.js';
import ProductDetailsCP from './pages/ ProductDetailsCP.js';
import ProductDetailsANT from './pages/ProductDetailsANT.js';
import ProjectWarehouse from './pages/ProjectWarehouse.js';
import ProjectAsset from './pages/ProjectAsset.js';
import AboutUs from './pages/AboutUs.js';
import Trucker from './pages/Trucker.js';
import Productrfid from './pages/Productrfid.js';
import ProductsPrinter from './pages/ProductsPrinter.js';
import ProductsLabels from './pages/ProductsLabels.js';
import SolutionsCattle from './pages/SolutionsCattle.js';
import SolutionLibrary from './pages/SolutionLibrary.js';
import SolutionLinen from './pages/SolutionLinen.js';



function App () {
  const [ifFirstTime , setifFirstTime] = useState(true)


 return (
  <>
  <HelmetProvider>
<Router>
    <Routes>
    <Route path="/" element={<Products />} />
    <Route path="/ContactPage" element={<ContactPage />} />
    <Route path="/ProductDetails" element={<ProductDetails />} />
    <Route path="/ProductDetailsP" element={<ProductDetailsP />} />
    <Route path="/ProductDetailsU" element={<ProductDetailsU />} />
    <Route path="/ProductDetailsCP" element={<ProductDetailsCP />} />
    <Route path="/ProductDetailsANT" element={<ProductDetailsANT />} />
    <Route path="/ProjectWarehouse" element={<ProjectWarehouse />} />
    <Route path="/ProjectAsset" element={<ProjectAsset />} />
    <Route path="/AboutUs" element={<AboutUs />} />
    <Route path="/Trucker" element={<Trucker />} />
    <Route path="/Productrfid" element={<Productrfid />} />
    <Route path="/ProductsPrinter" element={<ProductsPrinter />} />
    <Route path="/ProductsLabels" element={<ProductsLabels  />} />
    <Route path="/SolutionsCattle" element={<SolutionsCattle  />} />
    <Route path="/SolutionLibrary" element={<SolutionLibrary  />} />
    <Route path="/SolutionLinen" element={<SolutionLinen  />} />

    {/* <Route path="/Products" element={<Products />} /> */}

    </Routes>
    </Router>


  </HelmetProvider>

  
  </>
);
  }
export default App;
